import { Component, Event, EventEmitter, h, Prop } from '@stencil/core'

@Component({
  tag: 'user-premium-required',
})
export class UserPremiumRequired {
  @Event({ bubbles: false }) cancel: EventEmitter

  @Prop() upgradeUrl: string

  render() {
    return (
      <ui-dialog
        onClosed={() => {
          this.cancel.emit()
        }}
        content={() => (
          <div
            class='mx-auto h-46 bg-surface-upper rounded-md border-2 border-info-warn shadow-modal'
            style={{ width: '327px', minWidth: '327px', maxWidth: '327px' }}
          >
            <ui-icon
              onClick={() => {
                this.cancel.emit()
              }}
              class='absolute top-0 right-0 mt-12px mr-10px text-3xl text-surface-highest hover:text-glyph-base cursor-pointer'
              icon='x'
            />
            <div class='flex flex-col items-center pt-29px'>
              <ui-icon icon='stars' class='text-3xl text-info-warn' />
              <div class='flex pt-20px text-2xlarge font-extrabold text-info-warn'>Fathom Premium Required</div>
              <div class='flex pt-9px text-large font-semibold leading-17px text-center'>
                Due to AI costs, our advanced AI features
                <br /> are not available on the free plan.
              </div>
              <a
                href={this.upgradeUrl}
                class='flex justify-center items-center mt-26px w-49 h-34px bg-info-warn rounded'
              >
                <span class='text-base font-extrabold text-black'>Upgrade to Fathom Premium</span>
              </a>
            </div>
          </div>
        )}
      />
    )
  }
}
